<script>
    import {onMount, onDestroy} from 'svelte';

    export let time;

    let isVisible = false;

    function linearGrow(node, {
        delay = 0,
        duration = time
    }) {
        const o = (+getComputedStyle(node).transform.replace(/[^\d.]/g, '') / 100);

        return {
            delay,
            duration,
            css: t => `transform: scaleX(${t * o})`
        };
    }

    function setup() {
        isVisible = true;
    }

    function destroy() {
    }

    onMount(setup);
    onDestroy(destroy);
</script>

<style src="TransitionIndicator.scss"></style>

<div class="transition-indicator" style="transform: scaleX(0);" in:linearGrow></div>
